import { translateClaimOffer } from 'modules/offers/utils/translateClaimOffer';

export const translateUnclaimOffer = translateClaimOffer;
